import {
	FAIL_GET_KEIYAKU_KIGYOU_LIST_WD,
	GET_KEIYAKU_KIGYOU_LIST_WD,
	SUCCESS_GET_KEIYAKU_KIGYOU_LIST_WD,
	RESET_PROCESS_ERROR,
	GET_KEIYAKU_KIGYOU,
	SUCCESS_GET_KEIYAKU_KIGYOU,
	FAIL_GET_KEIYAKU_KIGYOU,
	CLEAR_KEIYAKU_KIGYOU,
	SET_KEIYAKU_KIGYOU,
	SUCCESS_SET_KEIYAKU_KIGYOU,
	FAIL_SET_KEIYAKU_KIGYOU,
	DEL_KEIYAKU_KIGYOU,
	SUCCESS_DEL_KEIYAKU_KIGYOU,
	FAIL_DEL_KEIYAKU_KIGYOU,
	RESTORE_KEIYAKU_KIGYOU,
	FAIL_RESTORE_KEIYAKU_KIGYOU,
	SUCCESS_RESTORE_KEIYAKU_KIGYOU, UPDATE_MASTER_FLAG
} from '../../actions';

const initialState = {
	data:{
		"KeiyakuKigyouName1":"",
		"JigyoushaShubetsu":"1",
		"KeiyakuKbn":"1",
		"ShimebiGroupCD":"5",
		"KaishuKbn":"1",
		"KaishuCycle":"1",
		"YokinShubetuKbn":"1",
		"TorihikiKbn":"1",
		"ZeiKbn":"1",
		"KingakuHasuShori":"1",
		"ZeiHasuShori":"1",
		"APIRenkeiFlag":"1",
		"APIRenkeiPassword":"",
		"ElectronicReceiptFlg":"0"
	},
	isFetching: false,
	keiyakukigyouData:[],
	error: undefined,
	isProcessError : false,
	isCompleteUpdate : false,
	keiyakuKigyouIsChanged:false,

};
export default function masterKeiyakuKigyouSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
    switch (action.type) {
		case GET_KEIYAKU_KIGYOU_LIST_WD:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_KEIYAKU_KIGYOU_LIST_WD:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_KEIYAKU_KIGYOU_LIST_WD:
			ret.keiyakukigyouData = action.payload.data.map(suggestion => ({
				value: suggestion.KeiyakuKigyouCD,
				label: suggestion.KeiyakuKigyouCD + ' : ' + suggestion.KeiyakuKigyouName + ((suggestion.DelFlag === "1") ? " (削除)" : ""),
			}));
			ret.isFetching = false;
			return ret;
		case GET_KEIYAKU_KIGYOU:
			ret.isFetching = true;
			return ret;
		case SUCCESS_GET_KEIYAKU_KIGYOU:
			if(action.payload.data){
				ret.data = action.payload.data;
			}
			else{
				ret.data = {
					"KeiyakuKigyouName1":"",
					"JigyoushaShubetsu":"1",
					"KeiyakuKbn":"1",
					"ShimebiGroupCD":"5",
					"KaishuKbn":"1",
					"KaishuCycle":"1",
					"YokinShubetuKbn":"1",
					"TorihikiKbn":"1",
					"ZeiKbn":"1",
					"KingakuHasuShori":"1",
					"ZeiHasuShori":"1",
					"APIRenkeiFlag":"1",
					"APIRenkeiPassword":"",
					"ElectronicReceiptFlg":"0"
				};
			}
			ret.keiyakuKigyouIsChanged = true;
			ret.isFetching = false;
			return ret;
		case FAIL_GET_KEIYAKU_KIGYOU:
			ret.isFetching = false;
			ret.isProcessError = true;
			ret.KeiyakuKigyouCD = null;
			return ret;
		case SET_KEIYAKU_KIGYOU:
		case DEL_KEIYAKU_KIGYOU:
		case RESTORE_KEIYAKU_KIGYOU:
			ret.isFetching = true;
			return ret;
		case SUCCESS_SET_KEIYAKU_KIGYOU:
		case SUCCESS_DEL_KEIYAKU_KIGYOU:
		case SUCCESS_RESTORE_KEIYAKU_KIGYOU:
			ret.isCompleteUpdate = true;
			ret.keiyakukigyouData = action.payload.data.map(suggestion => ({
				value: suggestion.KeiyakuKigyouCD,
				label: suggestion.KeiyakuKigyouCD + ' : ' + suggestion.KeiyakuKigyouName + ((suggestion.DelFlag === "1") ? " (削除)" : ""),
			}));
			ret.isFetching = false;
			return ret;
		case FAIL_SET_KEIYAKU_KIGYOU:
		case FAIL_DEL_KEIYAKU_KIGYOU:
		case FAIL_RESTORE_KEIYAKU_KIGYOU:
			ret.isFetching = false;
			ret.isProcessError = true;
			return ret;
		case CLEAR_KEIYAKU_KIGYOU:
			ret.isCompleteUpdate = false;
			ret.data = {
				"KeiyakuKigyouName1":"",
				"JigyoushaShubetsu":"1",
				"KeiyakuKbn":"1",
				"ShimebiGroupCD":"5",
				"KaishuKbn":"1",
				"KaishuCycle":"1",
				"YokinShubetuKbn":"1",
				"TorihikiKbn":"1",
				"ZeiKbn":"1",
				"KingakuHasuShori":"1",
				"ZeiHasuShori":"1",
				"APIRenkeiFlag":"1",
				"APIRenkeiPassword":"",
				"ElectronicReceiptFlg":"0",
			};
			ret.keiyakuKigyouIsChanged = false;
			ret.KeiyakuKigyouCD = null;
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		case UPDATE_MASTER_FLAG:
			return Object.assign({}, state, action.payload);
		default:
			return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/master/keiyaku-kigyou.js